import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const EthereumIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.748 11.353 3.025 8.598c-.195-.114-.4.131-.253.303l5.152 6.01a.1.1 0 0 0 .152 0l5.152-6.01c.147-.172-.058-.417-.252-.303l-4.724 2.755a.5.5 0 0 1-.504 0"
		></path>
		<path
			fill="currentColor"
			d="M3.109 6.538 7.85 1.17a.2.2 0 0 1 .3 0l4.742 5.368a.5.5 0 0 1-.129.766L8.247 9.86a.5.5 0 0 1-.493 0L3.237 7.304a.5.5 0 0 1-.128-.766"
		></path>
	</svg>
))
